import { Typography } from '@repo/web-ui/components/typography'

import { Card } from './card'
import type { CardVariant } from '../_hooks/use-my-account-card-variant'
import { useMyAccountCardVariant } from '../_hooks/use-my-account-card-variant'

import * as React from 'react'

export function MyAccountEmptyBlock({ variant }: { variant: CardVariant }) {
  const props = useMyAccountCardVariant(variant)
  return <EmptyBlock {...props} />
}

function EmptyBlock({
  title,
  description = '',
  icon,
  copy_1,
  copy_2,
  cta,
}: {
  title: string
  description?: string
  icon: JSX.Element
  copy_1: string
  copy_2: string
  cta?: JSX.Element
}) {
  return (
    <Card>
      <div className="flex flex-col gap-8">
        <div>
          <Typography variant="heading-3" className="capitalize text-gray-100">
            {title}
          </Typography>
          {description ? <Typography variant="body">{description}</Typography> : null}
        </div>
        <div className="flex flex-col items-center justify-center gap-4">
          {icon}
          <div>
            <Typography variant="body" className="text-cf-sf-gray-300 text-center">
              {copy_1}
            </Typography>
            <Typography variant="body" className="text-cf-sf-gray-300 text-center">
              {copy_2}
            </Typography>
          </div>
          {cta}
        </div>
      </div>
    </Card>
  )
}
